import { exactLength } from "utils/validator";

import { FieldError } from "../../error";
import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { isNumber } from "../../validate";

export class CanadaRoutingInstitutionIdField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "678",
      propertyName: "canadaRoutingInstitutionIdNumber",
      uiFieldType: "Input",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    if (registeredCountry === "Canada") {
      return true;
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    const value = this.value ?? "";

    if (!value) {
      return;
    }

    const errorMsg = "Must include 3 numbers only";

    const valueToValidate = "" + this.value;

    if (!isNumber(valueToValidate)) {
      throw new FieldError(this, errorMsg, "InvalidTypeNumber");
    }

    if (!exactLength(3)(valueToValidate)) {
      throw new FieldError(this, "Must be exact length 3", "InvalidLength");
    }
  }
}
